import { HttpInterceptorFn } from '@angular/common/http';
import { environments } from '../../../environments/environment';
import { isPublicApiRequest } from '../utils/auth-route.utils';

export const credentialsInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environments.apiUrl) || isPublicApiRequest(req.url, environments.apiUrl)) {
    return next(req);
  }

  return next(req.clone({ withCredentials: true }));
};
